define('../app/fukit/behavior/confirm.model.destroy.on.event.behavior',['require','exports','module','underscore','marionette','appkit/util/key.prefixer','backbone.radio','../helpers/route.helper','../view/block/confirm.destroy.modal.view','handlebars'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      Mn                      = require('marionette'),
      KeyPrefixer             = require('appkit/util/key.prefixer'),
      Radio                   = require('backbone.radio'),
      RouteHelper             = require('../helpers/route.helper'),
      ConfirmDestroyModalView = require('../view/block/confirm.destroy.modal.view'),
      Handlebars              = require('handlebars');

  var ConfirmModelDestroyOnPressBehavior = Mn.Behavior.extend({
    defaults: {
      eventName: 'press',
      eventSource: null,
      onNavigate: null,
      onConfirm: null,
      confirmEventName: '',
      destroyModel: true,
      routeOnDestroyOptions: null,
      destroyModelOptions: {
        wait: true,
      },
      // This method is called at the beginning of the onEvent method.  If preventOnEventHandler
      //  returns true, the rest of onEvent doesn't run.
      // The default is to prevent the event handler from firing if the element
      //  has the disallowed class.
      preventOnEventHandler: function() {
        return this.view.isAllowed === false;
      },
      // the options for the modal
      // Three important options are actionText, entityTypeText,
      // and entityText. These are used to display the proper text
      // for the destroy model.  They can also be used with bindings
      modalOptions: {
        closeable: true,
      },
      // same as modalOptions but kept for legacy support
      destroyViewOptions: null,
    },

    onFirstRender: function() {
      var eventSource = this.getOption('eventSource') || this.view;
      this.listenTo(eventSource, this.getOption('eventName'), this.onEvent);
      var model = this.getOption('model') || this.view.model;
      this.listenTo(model, 'destroy', this.routeOnDestroy);
    },

    // Sometimes we need to dynamically determine text options at render to evaluate the final text
    // Here, we check to see if a function has been passed instead of the expected string, and if so
    // evaluate it against the context of the behavior's "this".
    resolveTextOptions: function(options) {
      for (var option in options) {
        if (_.intersection([option], ['entityText', 'entityTypeText', 'actionText']).length > 0) {
          options[option] = _.isFunction(options[option]) ? options[option].call(this) : options[option];
        }
      }

      return options;
    },

    onEvent: function() {
      var preventOnEventHandler = this.getOption('preventOnEventHandler');
      if (preventOnEventHandler.bind(this)()) {
        return;
      }

      //prettier-ignore
      var model     = this.getOption('model') || this.view.model,
          onConfirm = this.getOption('onConfirm'),
          options   = _.extend({
              visible: true,
              type: ConfirmDestroyModalView
            },
            this.defaults.modalOptions,
            Mn._getValue(this.getOption('modalOptions'), this),
            // kept for legacy support
            this.getOption('destroyViewOptions')
          ),
          modalView;

      // Allow entityText, entityTypeText, and actionText to be a function
      options = this.resolveTextOptions(options);

      modalView = this.createConfirmDestroyModal(options);

      modalView.on(
        'confirm',
        function() {
          if (onConfirm) {
            onConfirm.call(this, model);
          }

          if (this.getOption('destroyModel') && model) {
            model
              .destroy(this.getOption('destroyModelOptions'))
              .promise()
              .catch(function(error) {
                // don't throw an error because some builds of Firefox don't like some of the things that Bluebird
                // is doing to clean up unresolved promises (see RSAM-1697), but let's log the error so it's not lost
                console.log(error);
              });
          }
          if (this.getOption('confirmEventName')) {
            this.view.triggerMethod(this.getOption('confirmEventName'));
          }
        },
        this
      );
    },

    createConfirmDestroyModal: function(options) {
      if (this.view.buildComponent) {
        return this.view.buildComponent(options);
      }
      throw new Error('The ConfirmModelDestroyOnPressBehavior was attached to a non-uikit view');
    },

    routeOnDestroy: function() {
      //prettier-ignore
      var onNavigate            = this.getOption('onNavigate'),
          onBeforeNavigate      = this.getOption('onBeforeNavigate'),
          routeOnDestroyOptions = this.getOption('routeOnDestroyOptions') || {},
          routeOnDestroyParams  = this.resolveRouteParams(routeOnDestroyOptions.params || {});

      if (!routeOnDestroyOptions.route) {
        return;
      }

      _.defer(function() {
        if (onBeforeNavigate) {
          onBeforeNavigate.call(this, routeOnDestroyOptions.route, routeOnDestroyParams);
        }
        RouteHelper.navigate(routeOnDestroyOptions.route, routeOnDestroyParams, { trigger: true });
        if (onNavigate) {
          onNavigate.call(this, routeOnDestroyOptions.route, routeOnDestroyParams);
        }
      });
    },

    resolveRouteParams: function(params) {
      //prettier-ignore
      var state = Radio.channel('AppKit.controllerService').request('state'),
          model = this.getOption('model') || this.view.model;

      return KeyPrefixer.resolve(params, {
        '@state.': function(stateKey) {
          if (state) {
            return state.get(stateKey);
          }
        },
        '@model.': function(modelKey) {
          if (model) {
            return model.get(modelKey);
          }
        },
      });
    },
  });

  return ConfirmModelDestroyOnPressBehavior;
});

